import { DevTool } from "@hookform/devtools";
import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import DataGrid from '../../components/common/dataGrid/dataGrid';
import ButtonWithSearch from '../../components/common/buttonWithSearch';
import { commonPostApi, commonGetApi } from "../../utils/apiService";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import {
  generateColumnMetadata,
  fetchOptions,
  orderObj,
  dateFormat,
  generateValidObject,
  Feature,
  convertToNameLabel,
  convertToSearchField
} from "../../utils/utils";
import ProfileView from '../../components/common/profileView';
import PrimarySideBar from '../../components/common/sideBar/primarySideBar';
import InputIterator from '../../components/common/inputIterator';
import AddImageSection from '../../components/common/AddImageSection';
import AddButtonSection from '../../components/common/AddButtonSection';
import CommonModal from '../../components/common/commonModel';
import { campFormRender, OrganizationCampsColumns } from "../../utils/serviceData";
import { showToast } from '../../components/common/toast';
import { TOAST_TYPE, COMMON_MSG, FEATURE_MSG } from "../../constants/toast";
import { SORT_ORDER } from "../../constants/sortOrder";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { organizationFormRender } from "../../utils/serviceData";
import moment from "moment";
import { exportCSV, exportExcel, exportPdf } from "../../utils/exportUtils";

export default function OrganizationCampList() {
  const {
    control,
    formState: { errors, dirtyFields },
    handleSubmit,
    reset,
    setValue,
    trigger
  } = useForm({mode:"onChange",reValidateMode:"onChange"});
  const menuLeft = useRef(null);
  const { organization_id } = useParams();
  const [columns, setColumns] = useState([]);
  const [values, setValues] = useState([]);
  const [initLoading, setInitLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [addCampVisible, setAddCampVisible] = useState(false);
  const [editCampVisible, setEditCampVisible] = useState(false);
  const [visible, setVisible] = useState({});
  const [selectedRow, setSelectedRow] = useState({});
  const [campDetails,SetcampDetails]=useState([]);
  const [campFormState, setCampFormState] = useState(campFormRender);
  const [organizationFormState, setOrganizationFormState] = useState(organizationFormRender);
  const [uploadedImg, setUploadedImg] = useState(null);
  const searchFields=["camp_name","camp_code","start_date","end_date","camp_type_name","frequency_name","city"];
  const [campUploadedImg, setCampUploadedImg] = useState(null);
  const [organization, setOrganization] = useState({});
  const [isEditOrganizationDetails, setIsEditOrganizationDetails] = useState(false);
  const [editOrgDetails, setEditOrgDetails] = useState({});
  const [existingOrgnames, setExistingOrgnames] = useState([]);
  const [navigator, setNavigator] = useState({
    page: 1,
    first: 0,
    rows: 10,
    totalRecords: 1,
    sortBy: "camp_name",
    sortDir: SORT_ORDER.ASC,
    searchCriteria: {
      organization_id: organization_id,
      ...convertToSearchField(searchFields,"")
    },
  });
  const navigate = useNavigate();
  const fields = [
    "camp_name",
    "description",
    "organization_id",
    "start_date",
    "end_date",
    "frequency",
    "camp_type_id",
    "pincode",
    "contact_number",
    "contact_name",
    "city",
    "state",
    "district",
    "address",
  ];
  const orgFields = [
    "organization_name",
    "description",
    "address",
    "city",
    "district",
    "state",
    "pincode",
    "contact_person",
    "contact_number"
  ];
  const keyMapping = {
    organization_code: "organization_code",
    state: "location",
    city: "city",
    pin_code: "pin_code",
    contact_person: "contact_person",
    district: "district",

  };

 const ORGANIZATIONDETAILS =async()=>{
      Promise.all([
      commonPostApi(API_ENDPOINTS.ORGANIZATION_DETAILS, { query: { limit: 100 } }),
      commonGetApi(API_ENDPOINTS.CAMP_TYPE),  
    ]).then(([ organization, camptype]) => {
           setCampFormState((prev) =>
          prev.map((formInput) => {
            if (formInput?.name === "organization_id") {
              return {
                ...formInput,
                options:
                  organization?.data?.data?.map?.((org) => ({
                    ...org,
                    label: org?.organization_name,
                    value: org?.organization_id,
                  })) || [],
              };
            } else if (formInput?.name === "camp_type_id") {
              return {
                ...formInput,
                options:
                  camptype?.data?.data?.map?.((org) => ({
                    ...org,
                    label: org?.camp_type_name,
                    value: org?.camp_type_id,
                  })) || [],
              };
            } else return formInput;
          })
        );
      })
  }

  const ExsistingCampDetails = async()=>{
      commonGetApi(API_ENDPOINTS.GET_ALL_NOTIFICATION_CAMPS)
      .then((campdetailsData)=> SetcampDetails(campdetailsData?.data?.data))
  }



  function onPageChange(event) {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      first: event?.first,
      page: event.page + 1,
    }));
    init({
      ...navigator,
      first: event?.first,
      page: event.page + 1,
    });
  }

  function onRowCountChange(e) {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      rows: e?.target?.value,
      page: 1,
      first: 0,
    }));
    init({
      ...navigator,
      rows: e?.target?.value,
      page: 1,
      first: 0,
    });
  }

  const init = async (navigator) => {
    setInitLoading(true);
    let currentObj = {
      query: {
        page: navigator?.page,
        limit: navigator?.rows,
        sortFields: navigator?.sortFields,
        searchCriteria: navigator?.searchCriteria,
      },
    };

    Promise.all([
      commonPostApi(API_ENDPOINTS.CAMP_DETAILS, currentObj),
    ])
      .then(([data]) => {
        const userData = data?.data?.data;
        setNavigator((prev) => ({
          ...prev,
          totalRecords: data?.data?.total,
          page: data?.data?.currentPage,
        }));

        setColumns(
          orderObj(
            [
              "camp_name",
              "camp_code",
              "start_date",
              "end_date",
              "camp_type_name",
              "frequency_name",
              "city",
            ],
            generateColumnMetadata({
              data: userData,
              alias: {
                camp_name: "name",
                camp_code: "id",
                start_date: "start",
                end_date: "end",
                camp_type_name: "type",
                frequency_name: "freq",
                city: "location",
              },
              defaultColumnsArr: OrganizationCampsColumns,
            })
          )
        );
        setValues(userData);
        setLoading(false);
        setInitLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };


  const onSortClick = (event) => {
    setLoading(true);
    const sortOrder = event?.sortOrder === 1 ? SORT_ORDER.ASC : SORT_ORDER.DESC;
    setNavigator((prev) => ({
      ...prev,
      sortBy: event?.sortField,
      sortDir: sortOrder,
      sortFields: [[event?.sortField, sortOrder]],
    }));
    init({
      ...navigator,
      sortBy: event?.sortField,
      sortDir: sortOrder,
      sortFields: [[event?.sortField, sortOrder]],
    });
  };

  const onSubmit = async (data) => {
    if (loader) return;
    setLoader(true);

    if (uploadedImg?.size > 800 * 1024) {
      showToast(TOAST_TYPE.ERROR, COMMON_MSG.VALIDATION.FILE_SIZE_EXCEEDED);
      setLoader(false);
      return;
    }
    let headers = {
      "Content-Type": "application/json",
    };
    const addCamp = {
      ...data,
      start_date: dateFormat(data["start_date"]),
      end_date: dateFormat(data["end_date"]),
    };
    let finalData = addCamp;
    if (campUploadedImg && campUploadedImg.size && campUploadedImg.size > 0) {
      finalData = new FormData();
      finalData.append("profile_picture", campUploadedImg);
      finalData.append("_payload", JSON.stringify(addCamp));
      headers = {
        "Content-Type": "multipart/form-data",
      };
    } else {
      headers = {
        "Content-Type": "application/json",
      };
    }
    await commonPostApi(API_ENDPOINTS.ADD_CAMP_DETAILS, finalData, {
      headers,
    })
      .then((data) => {
        if (data?.message) {
          showToast(TOAST_TYPE.ERROR, data?.message);
          setLoader(false);
        } else {
          showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.CAMP.ADDED);
          setAddCampVisible(false);
          init(navigator);
          reset();
          setLoader(false);
        }
      })
      .catch((err) => {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
        setLoader(false);
      });
  };

  const onEdit = async (data) => {
    if (loader) return;
    setLoader(true);

    let editCamp = {
      ...data,
      camp_details_id: selectedRow?.camp_details_id,
      start_date: dateFormat(data["start_date"]),
      end_date: dateFormat(data["end_date"]),
      organization_id: data["organization_id"],
    };
    let finaldata;
    let headers = {};
    if (campUploadedImg instanceof File) {
      finaldata = new FormData();
      finaldata.append("profile_picture", campUploadedImg);
      finaldata.append("_payload", JSON.stringify(editCamp));
      headers = { "Content-Type": "multipart/form-data" };
    } else {
      finaldata = JSON.stringify(editCamp);
      headers = { "Content-Type": "application/json" };
    }
    await commonPostApi(

      API_ENDPOINTS.EDIT_CAMP_DETAILS,
      finaldata,
      {
        headers,
      }
    )
      .then((data) => {
        if (data?.status == 200) {
          showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.USER.UPDATED);
          setEditCampVisible(false);
          init(navigator);
          reset();
          setLoader(false);
        } else {
          showToast(TOAST_TYPE.ERROR, data?.message ?? COMMON_MSG.ERROR.GENERIC);
          setLoader(false);
        }
      })
      .catch((err) => {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
        setLoader(false);
      });
  };

  const onDelete = async () => {
    let headers = {
      "Content-Type": "application/json",
    };
    await commonPostApi(
      API_ENDPOINTS.DELETE_USER_DETAILS,
      { user_id: visible?.id },
      {
        headers,
      }
    )
      .then((data) => {
        if (data?.status == 200) {
          showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.USER.DELETED);
          init(navigator);
          setVisible((prev) => ({
            ...prev,
            show: false,
          }));
        }
      })
      .catch((err) => {
        showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
      });
  };

  const button = [
    {
      type: "primarySuccessButton",
      label: "Add Camp",
      icon: "pi pi-plus",
      class: "mt-2 w-full flex pr-4",
      onClick: () => {
        setAddCampVisible(true);
        setSelectedRow({ organization_id: organization_id });
        setCampUploadedImg({});

      },
    },
  ];
  const buttonEdit = [
    {
      tyep: "primarySuccessButton",
      label: "Edit",
      class: "card-button-edit",
      onClick: () => {
        setIsEditOrganizationDetails(true);
        setEditOrgDetails(organization?.originalData);
      },
    },
  ];
  const itemRenderer = (item, props) => (
    <div className="p-menuitem-content">
      {item.label === "Edit" && Feature?.featureVerify(Feature.listOfFeature.campEdit) && (
        <Button
          className="card-button-edit-secound"
          label="Edit"
          onClick={() => {
            setEditCampVisible(true);
            const imgUrl = props?.props?.itemProp.profile_picture
              ? `${process.env?.REACT_APP_CURRENT_URL}${API_ENDPOINTS.SEARCH_IMAGE_BY_ID(props?.props?.itemProp?.camp_details_id)}`
              : null;

            setSelectedRow(props?.props?.itemProp);
            setCampUploadedImg(imgUrl);
          }}
        />
      )}
      {/* {item.label === "Delete" && (
        <Button
          className="card-button-delete"
          label="Delete"
          onClick={() => {
            setVisible({
              id: props?.props?.itemProp?.user_id,
              show: true,
            });
          }}
        />
      )} */}
    </div>
  );



  const AddCampbuttons = [
    {
      type: "primarySuccessButton",
      label: "Submit",
      class: "col-4",
      disabled: Object.keys(dirtyFields).length === 0 || loader,
      onClick: handleSubmit(onSubmit),
    },
    {
      type: "primaryCancelButton",
      label: "Cancel",
      class: "col-4",
      onClick: () => {
        reset();
        setAddCampVisible(false);



      },
    },
  ];

  const onEditOrganization = async (data) => {
    if (loader) return;
    setLoader(true);
    try {
      let headers = {};
      let validObj = generateValidObject(data);
      const dob = dateFormat(validObj["dob"]);
      validObj = {
        ...validObj,
        dob: dob,
        organization_id: editOrgDetails?.organization_id
      };
      let finaldata = validObj;
      if (uploadedImg && uploadedImg.size && uploadedImg.size > 0) {
        finaldata = new FormData();
        finaldata.append("profile_picture", uploadedImg);
        finaldata.append("_payload", JSON.stringify(validObj));
        headers = {
          "Content-Type": "multipart/form-data",
        };
      } else {
        headers = {
          "Content-Type": "application/json",
        };
      }
     const updateRes = await commonPostApi(
       API_ENDPOINTS.EDIT_ORGANIZATION_DETAILS,
       finaldata,
       { headers },
     ); 

     if (updateRes?.status === 200 || updateRes?.data) {
       showToast(TOAST_TYPE.SUCCESS, FEATURE_MSG.ORGANIZATION.UPDATED);
       setIsEditOrganizationDetails(false);
     }
      const response = await commonPostApi(API_ENDPOINTS.SEARCH_ORGANIZATION_DETAILS, { organization_id: editOrgDetails?.organization_id });
      const res = response?.data?.data;
      const filteredData = Object.keys(keyMapping).reduce((acc, key) => {
        if (res[key] !== undefined) {
          acc[key] = res[key];
        }
        return acc;
      }, {});

      const finalData = convertToNameLabel(filteredData)
      finalData.name = res["organization_name"];
      finalData.imgUrl = uploadedImg instanceof File
      ? URL.createObjectURL(uploadedImg)
      :res?.profile_picture
      ?`${process.env?.REACT_APP_CURRENT_URL}${API_ENDPOINTS.SEARCH_IMAGE_BY_ID(res?.organization_id)}`
      : null;
      setUploadedImg(finalData.imgUrl);
      setOrganization({finalData,originalData:res})
      reset();
    } catch (err) {
      showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
    } finally {
      setLoader(false);
    }
  };

  const EditCampbuttons = [
    {
      type: "primarySuccessButton",
      label: "Submit",
      class: "col-4",
      onClick: () => isEditOrganizationDetails ? handleSubmit(onEditOrganization)() : handleSubmit(onEdit)(),
      disabled: loader || (Object.keys(dirtyFields).length === 0 && !uploadedImg)
    },
    {
      type: "primaryCancelButton",
      label: "Cancel",
      class: "col-4",
      onClick: () => {
        reset();
        setEditCampVisible(false);
        setIsEditOrganizationDetails(false);
        setUploadedImg(organization.finalData.imgUrl);
      },
    },
  ];

  const submitButtons = [
    {
      type: "primarySuccessButton",
      label: "Yes",
      class: "w-8rem pr-3",
      onClick: () => {
        onDelete();
      },
    },
    {
      type: "secondaryButton",
      label: "No",
      class: "w-7rem",
      onClick: () => {
        setVisible((prev) => ({
          ...prev,
          show: false,
        }));
      },
    },
  ];

  const initiateForm = () => {
    fetchOptions("CAMP_FREQUENCY", (frequency) => {
      setCampFormState((prev) =>
        prev.map((item) => {
          if (item?.name == "frequency") return { ...item, options: frequency };
          else return item;
        })
      );
    });
  };

const getExistingOrganizations = async () => {
  try {
    const res = await commonGetApi(API_ENDPOINTS.GET_EXISTING_ORGANIZATIONS);
    const names =
      res?.data?.data?.rows?.map((org) =>
        org?.organization_name?.toLowerCase()?.trim(),
      ) || [];

    setExistingOrgnames(names);
  } catch (error) {
    console.log("Error fetching organizations", error);
  }
};

  useEffect(() => {
    initiateForm();
    ExsistingCampDetails();
    ORGANIZATIONDETAILS();
    getExistingOrganizations();
    init(navigator);
  }, []);

useEffect(() => {
  if (!existingOrgnames.length) return;

  const updateForm = organizationFormRender.map((field) => {
    if (field.name === "organization_name") {
      return {
        ...field,
        rules: {
          ...field.rules,
          validate: (value) => {
            if (!value) return true;

            const normalized = value.toLowerCase().trim();

            if (
              normalized ===
              editOrgDetails?.organization_name?.toLowerCase()?.trim()
            ) {
              return true;
            }

            return existingOrgnames.includes(normalized)
              ? "Organization name already exists"
              : true;
          },
        },
      };
    }
    return field;
  });

  setOrganizationFormState(updateForm);

  trigger("organization_name");

}, [existingOrgnames, editOrgDetails]);

  useEffect(() => {
    const fetchOrganization = async () => {
      try {
        setLoading(true);
        const response = await commonPostApi(API_ENDPOINTS.SEARCH_ORGANIZATION_DETAILS, { organization_id: organization_id })
        const res = response?.data?.data;
        const finalList = {};
        const keyMapping = {
          organization_code: "organization_code",
          state: "location",
        };
        [
          "organization_code",
          "state",
          "city",
          "pin_code",
          "contact_person",
          "district",
        ].forEach((item) => {
          finalList[keyMapping[item] || item] = res[item];
        });

        let finalData = convertToNameLabel(finalList, [
          "organization_id",
          "organization_name",
          "created_at",
          "created_by",
          "updated_at",
          "updated_by",
          "description",
          "address",
          "profile_picture",
          "contact_number",
          "tenant_id",
        ]);
        finalData.name = res["organization_name"];
        finalData.imgUrl = res?.profile_picture
          ? `${process.env?.REACT_APP_CURRENT_URL}${API_ENDPOINTS.SEARCH_IMAGE_BY_ID(res?.organization_id)}`
          : null;
        setUploadedImg(finalData.imgUrl)
        finalData = Object.entries(finalData)
          .map(([label, value]) => ({ [label]: value }))
          ?.reduce((acc, item) => {
            const normalizedItem =
              Array.isArray(item) && item.length === 1 ? item[0] : item;
            return { ...acc, ...normalizedItem };
          }, {});

        setOrganization({ finalData, originalData: res })
      } catch (error) {
        console.error("Error fetching organization:", error);
      } finally {
        setLoading(false);
      }
    };

    if (organization_id) {
      fetchOrganization();
    }
  }, [organization_id]);

  useEffect(() => {
    if (isEditOrganizationDetails && editOrgDetails) {
      orgFields.forEach((field) => setValue(field, editOrgDetails[field]));
    }
  }, [isEditOrganizationDetails, editOrgDetails]);

  useEffect(() => {
    fields.forEach((fieldName) => {
      if (["start_date", "end_date"].includes(fieldName)) {
        const dateValue = selectedRow?.[fieldName];
        if (dateValue) {
          const parsedDate = moment(dateValue, "DD-MM-YYYY")?._d;
          setValue(fieldName, parsedDate && !isNaN(parsedDate?.getTime()) ? parsedDate : null);
        } else {
          setValue(fieldName, null);
        }
      } else {
        setValue(fieldName, selectedRow?.[fieldName]);
      }
    });
  }, [selectedRow, editCampVisible]);

useEffect(()=>{
  if(!campDetails?.length) return;

  setCampFormState((prev)=>
    prev.map((field)=>{
      if(field.name === "camp_name"){
        return{
          ...field,
          rules:{
            ...field.rules,
            validate:(value)=>{
              const exists = campDetails.some(
                (camp)=>camp?.camp_name?.toLowerCase().trim() === value?.toLowerCase().trim()
              );
              return exists ? "Camp Name already exists" : true;
            },
          },
        };
      }
      return field;
    })
  );

  trigger("camp_name")

},[campDetails]);

  const handleSeachChange = (value) => {
    const data = {
      searchvalue:value
    }
    setNavigator((prev) => {
      return {
        ...prev,
        searchCriteria: {
         organization_id: organization_id,
          ...data
        },
      };
    });
    init({
      ...navigator,
      searchCriteria: {
         organization_id: organization_id,
        ...data
      },
    });
  };
  const onRowClick = (event) => {
    if (Feature?.featureVerify(Feature.listOfFeature.campView)) {
      navigate(`/camp/${event?.data?.camp_details_id}`);
    }
  };

  const fetchAllCampList = async () =>{
    const exportObj={
      query:{
        page:1,
        limit:navigator.totalRecords,
        sortFields:[[navigator.sortBy, navigator.sortDir]],
        searchCriteria:navigator.searchCriteria,
      },
    };
    const res = await commonPostApi(API_ENDPOINTS.CAMP_DETAILS,exportObj);
    return res?.data?.data || [];
  };

  return (
    <div className="Visits__main-container">
      <>
        <ProfileView
          profile={organization.finalData}
          button={Feature?.featureVerify(Feature?.listOfFeature?.organizationEdit) && buttonEdit}
          loading={loading}
          parentClass="ml-auto"
        />
      </>

      <DataGrid
        header={
          <ButtonWithSearch
            buttons={button}
            searchHeaderLable={"Camps"}
            searchPlaceHolder={"Search Camps"}
            isSearchEnabled={true}
            isDownloadButton={true}
            isCalenderEnabled={false}
            isButtonEnabledLeft={false}
            exportCSV={async () =>{
              const allData = await fetchAllCampList();
              exportCSV(allData, columns, "camps");
            }}
            exportExcel={async () =>{
              const allData = await fetchAllCampList();
              exportExcel(allData, columns, "camps");
            }}
            exportPdf={async () =>{
              const allData = await fetchAllCampList();
              exportPdf(allData, columns, "camps");
            }}
            isButtonEnabledRight={Feature?.featureVerify(Feature.listOfFeature.campAdd)}
            loading={initLoading}
            styles={{ gridTemplateColumns: "1fr 400px" }}
            onChange={handleSeachChange}
          />
        }
        onSortClick={onSortClick}
        onRowCountChange={onRowCountChange}
        onPageChange={onPageChange}
        isPaginatorEnabled={true}
        navigator={navigator}
        column={columns}
        value={values}
        ref={menuLeft}
        loading={loading}
        sortable
        optionsView={Feature?.featureVerify(Feature.listOfFeature.organizationEdit) && [
          {
            items: [
              {
                label: "Edit",
                icon: "pi pi-pencil",
                template: itemRenderer,
              },
              {
                label: "Delete",
                icon: "pi pi-upload",
                template: itemRenderer,
              },
            ],
          },
        ]}
      />
      {addCampVisible && (
        <PrimarySideBar
          visible={addCampVisible}
          onHide={() => {
            reset();
            setAddCampVisible(false)
          }}
          header={<div className="sideBar-header">Add Camp</div>}
        >
          <AddImageSection showImg={campUploadedImg} setImg={setCampUploadedImg} />
          <InputIterator
            control={control}
            errors={errors}
            formRender={campFormState}
          />
          <div className="pt-3">
            <AddButtonSection disabled={loader} buttons={AddCampbuttons} />
          </div>
        </PrimarySideBar>
      )}
      {editCampVisible && (
        <PrimarySideBar
          visible={editCampVisible}
          onHide={() => {
            reset();
            setEditCampVisible(false)
          }}
          header={<div className="sideBar-header">Edit Camp</div>}
        >
          <AddImageSection showImg={campUploadedImg} setImg={setCampUploadedImg} />
          <InputIterator
            control={control}
            errors={errors}
            formRender={campFormState}
          />
          <div className="pt-3">
            <AddButtonSection buttons={EditCampbuttons} />
          </div>
        </PrimarySideBar>
      )}
      {isEditOrganizationDetails && (
        <PrimarySideBar
          visible={isEditOrganizationDetails}
          onHide={() => {
            reset();
            setUploadedImg(organization.finalData.imgUrl);
            setIsEditOrganizationDetails(false)
          }}
          header={<div className="sideBar-header">Edit Organization</div>}
        >
          <AddImageSection
            showImg={uploadedImg}
            setImg={setUploadedImg}

          />

          <InputIterator
            control={control}
            errors={errors}
            formRender={organizationFormState}
          />
          <div className="pt-3">
            <AddButtonSection disabled={loader} buttons={EditCampbuttons} />
          </div>

        </PrimarySideBar>
      )}


      <CommonModal
        visible={visible?.show}
        header="User Patient"
        onHide={() => setVisible(false)}
      >
        <div>
          <div className="flex justify-content-center pr-4">
            Would you like to delete this user?
          </div>

          <div className="mt-6 ml-2">
            <AddButtonSection buttons={submitButtons} />
          </div>
        </div>
      </CommonModal>
      <DevTool control={control} />
    </div>
  );
}
